import React from "react";
import { usePageSEO } from "@/hooks/use-seo";
import PublicHeader from "@/components/layout/PublicHeader";
const About: React.FC = () => {
  usePageSEO("About Zoocertica — Compliance Platform for Zoos & Sanctuaries", "Learn about Zoocertica's mission to streamline wildlife facility compliance and regulatory management.", "/about");
  return <div className="min-h-screen bg-background">
      <PublicHeader />
      <div className="container mx-auto py-8 px-4 max-w-4xl">
        <div className="space-y-8">
          <div className="text-center space-y-4">
            <h1 className="text-4xl font-bold tracking-tight">About Zoocertica — The Compliance Platform for Zoos, Sanctuaries, and Wildlife Facilities</h1>
            <p className="text-xl text-muted-foreground">
              Professional wildlife facility management and regulatory compliance — built for organizations that care about doing things right.
            </p>
          </div>

          <div className="grid gap-8 md:grid-cols-2">
            <div className="space-y-4">
              <h2 className="text-2xl font-semibold">Our Mission</h2>
              <p className="text-muted-foreground">
                Zoocertica consolidates CITES permits, USDA licenses, state regulations, veterinary records, and transport documentation into one inspection-ready platform. We help zoos, sanctuaries, aquariums, and accredited research facilities maintain full compliance, simplify audits, and focus on what matters most — animal welfare and conservation.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-2xl font-semibold">What We Do</h2>
              <ul className="space-y-2 text-muted-foreground">
                <li>• Centralized CITES and USDA permit tracking</li>
                <li>• State-by-state legality summaries</li>
                <li>• Automated expiration alerts</li>
                <li>• Animal inventory with complete audit trails</li>
                <li>• Veterinary records and health monitoring</li>
                <li>• Inspection scheduling and audit-ready exports</li>
                <li>• Transport certificates and logistics</li>
                <li>• AI-Assisted regulatory compliance research</li>
              </ul>
            </div>

            <div className="space-y-4">
              <h2 className="text-2xl font-semibold">Key Features</h2>
              <ul className="space-y-2 text-muted-foreground">
                <li>• Multi-facility compliance dashboard</li>
                <li>• Automated permit expiration alerts</li>
                <li>• Audit-ready exports and reports</li>
                <li>• Role-based access and security</li>
                <li>• Secure cloud-based infrastructure</li>
                <li>• State legality AI assistant</li>
                <li>• Mobile-responsive design</li>
                <li>• Complete data backup and recovery</li>
              </ul>
            </div>

            <div className="space-y-4">
              <h2 className="text-2xl font-semibold">Who We Serve</h2>
              <p className="text-muted-foreground">Zoocertica is built for AZA-accredited zoos, wildlife sanctuaries, aquariums, rehabilitation centers, and research institutions that need to maintain rigorous compliance with CITES, USDA, and state regulations. We also support licensed private collectors managing reptiles and aquatic species under permit requirements.</p>
            </div>
          </div>

          <div className="text-center space-y-4 pt-8 border-t">
            <h2 className="text-2xl font-semibold">Ready to Get Started?</h2>
            <p className="text-muted-foreground">
              Join zoos, sanctuaries, and accredited wildlife facilities nationwide that trust Zoocertica to maintain inspection-ready compliance and streamline regulatory workflows. Start your 14-day free trial today.
            </p>
            <div className="flex justify-center pt-4">
              <a href="mailto:support@zoocertica.com" className="text-primary hover:underline font-medium">
                Contact us at support@zoocertica.com for demos, feature requests, and general inquiries
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default About;